import { render } from "./messageList.vue?vue&type=template&id=67bfea4e&scoped=true&ts=true"
import script from "./messageList.vue?vue&type=script&lang=ts"
export * from "./messageList.vue?vue&type=script&lang=ts"

import "./messageList.vue?vue&type=style&index=0&id=67bfea4e&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bfea4e"]])

export default __exports__